import { FaPlay, FaStop, FaUndo } from "react-icons/fa";

import React from "react";
import { iTimer } from "./types";

const TimerControls = ({ timer }: { timer: iTimer }) => (
    <>
        <button
            type="button"
            disabled={timer.isRunning()}
            onClick={() => timer.start()}
        >
            <FaPlay />
        </button>
        <button
            type="button"
            disabled={!timer.isRunning()}
            onClick={() => timer.stop()}
        >
            <FaStop />
        </button>
        <button
            type="button"
            disabled={!timer.from}
            onClick={() => timer.reset()}
        >
            <FaUndo />
        </button>
    </>
);

export default TimerControls;
